import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import AppBarInner from '../components/app-bar/AppBarInner'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import { ButtonOutlined } from '../components/app-button/button'
import Spinner from '../components/spinner'
import CustomizeAll from '../components/сustomize-all/'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Popup from '../components/popup'
import AcceptTerm from '../components/accept-term/'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  logo_inner: {
    width: 40,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  description_bottom: {
    width: '100%',
  },
  logo_top: {
    width: '100%',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    marginLeft: 74,
  },
  email: {
    color: '#5856d6',
  },
})

function getSteps() {
  return [
    `Подтвердите \nаккаунт`,
    'Добавьте сайт \nдля анализа',
    'Настройте \nGoogle Analytics \nдля отображения \nрасширенных \nотчетов',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class Verify extends Component {
  state = {
    activeStep: 0,
    user: window.state.user,
    isCard: window.state.cardTest,
  }

  handleEmailResend = () => {
    this.setState({
      isFetching: true,
      open: false,
    })

    const url = '/email/resend'

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    const json = response => {
      return response.json()
    }

    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })
      .then(status)
      .then(json)
      .then(data => {
        this.setState({
          isFetching: false,
          open: true,
        })
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    this.setState({ open: false })
  }

  render() {
    const { classes } = this.props
    const { user, isFetching, isCard } = this.state
    const steps = isCard ? getSteps() : getSteps().slice(0, -1)
    const description = `Чтобы начать использовать систему, \n перейдите по ссылке в письме, \n высланном на адрес `

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        {!user.agree_with_offer_date && <AcceptTerm />}
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />

          <AppStepper activeStep={this.state.activeStep} steps={steps} />

          <div className={classes.wizardContent}>
            <Typography variant="body1" style={{ whiteSpace: 'pre-line' }}>
              {description}
              <span className={classes.email}>{user.email}</span>
            </Typography>
            <ButtonOutlined
              handleClick={this.handleEmailResend}
              style={{
                maxWidth: 280,
                width: '100%',
                height: 40,
                marginTop: 22,
                padding: 0,
              }}
              color="secondary"
              text={
                isFetching ? (
                  <Spinner stroke={'#8866ff'} />
                ) : (
                  'Выслать письмо повторно'
                )
              }
            />
          </div>
        </div>
        
        <Popup/>  

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.open}
          autoHideDuration={6000}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Письмо отправлено</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    )
  }
}

export default withStyles(styles)(Verify)
